import { render, staticRenderFns } from "./ModalProductFamiliesGroup.vue?vue&type=template&id=9ff8e774&"
import script from "./ModalProductFamiliesGroup.vue?vue&type=script&lang=js&"
export * from "./ModalProductFamiliesGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports